import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AppLoadingService } from '../../services/apploading.service';
import { GeneralService } from '../../services/general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { AbstractForm } from '../../utils/abstract-form';
import { ReasonComponent } from '../reason/reason.component';
import { API } from 'src/app/configs';
import { AdSearchService } from '../../services/adsearch.service';

@Component({
  selector: 'dialog-material',
  templateUrl: 'dialog-material.component.html',
  styleUrls: ['./dialog-material.component.scss']
})
export class DialogMaterialComponent extends AbstractForm implements OnInit, OnDestroy {

  init = false;

  buttonsDisabled = false;

  personData: any = [];

  min = 5;
  max = 255;

  view = false;


  protected personDataSubscription: Subscription;
  protected filesSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    protected gs: GeneralService,
    protected als: AppLoadingService,
    protected httpService: HttpService,
    protected formBuilder: FormBuilder,
    protected srs : AdSearchService,
    logger: LoggerService
  ) { 

    super(formBuilder, logger, true);

    this.personDataSubscription = this.gs.generalData$.subscribe((result) => {
      if (!!result?.person?.length) {
          this.personData = result?.person[0];
      }
    });
  }


  buildFormGroup(): FormGroup {
    
    return this.formBuilder.group({
      message: ['', [Validators.required, Validators.minLength(this.min), Validators.maxLength(this.max)]]
    });

  }

  updateControls() { }
  updateObject(): any { }


  ngOnInit(){
    this.view = ['-1','2'].indexOf(this.data.status) > -1;
    this.init=true; 
    
    if(this.view){
      this.setControlValue('message',this.data?.decided_message || '(Motivo não preenchido)');
    }
  }

  ngOnDestroy(){
    this.personDataSubscription?.unsubscribe();
    this.filesSubscription?.unsubscribe();
  }

  modalClose(){
    this.dialog.getDialogById(this.data.modalId).close();
  }

  openAd(event, public_idtext){
    this.srs.action(event, 'view', public_idtext);
    this.modalClose();
  }


  openProfile(ev, public_idtext){
    this.gs.openProfile(ev, public_idtext);
  }

  async send(event){
    this.buttonsDisabled=true;

    let values :any = this.getFormValues();

    await this.als.setLoaded(false, 'materialAllow');

    await this.httpService.post<any>(API.person.general.material.allow, {
      "owner_person_id": this.data.owner_person_id,
      "person_request_id": this.data.person_request_id,
      "update": this.data.update,
      "message" : values.message
    })
      .then(async result => {
        
        this.gs.error({}, 'Resposta da solicitação enviada');
        this.gs.transactionData.next({method:'requestMaterial', action:'reload'});
        this.modalClose();
      })
      .catch((err) => {
        this.gs.error(err);
      })
      .finally(() => {
        this.buttonsDisabled=false;
        this.als.setLoaded(true, 'materialAllow');
      });

  }

  async reject(event){
    event.stopPropagation();
    let modalId = 'ReasonComponent_'+Math.random();
    const dialogRef = this.dialog.open(ReasonComponent, 
    {   disableClose : true,
        id:modalId,
        data: {
          modalId:modalId,
          subtitle : 'Caso não queira justificar a rejeição, deixe o campo vazio'
        }
    });
    dialogRef.afterClosed().subscribe(async result => {
      if(typeof result?.reason != 'undefined'){
        await this.als.setLoaded(false, 'materialReject');
        await this.httpService.post<any>(API.person.general.material.reject, {
          "owner_person_id": this.data.owner_person_id,
          "person_request_id": this.data.person_request_id,
          "update": this.data.update,
          "message" : result.reason
        })
          .then(async result => {
            
            this.gs.error({}, 'Solicitação de material físico rejeitado');
            this.gs.transactionData.next({method:'requestMaterial', action:'reload'});
            this.modalClose();
          })
          .catch((err) => {
            this.gs.error(err);
          })
          .finally(() => {
            this.als.setLoaded(true, 'materialReject');
          });
      }
    });
  }
}